import {Address} from "../redux/types";
import React, {FC} from "react";
import {Form, Formik} from "formik";
import * as yup from "yup";
import clsx from "clsx";
import {CircularProgress, IconButton, makeStyles, Typography} from "@material-ui/core";
import {useHistory} from "react-router-dom";
import {FormikDcbAddressInput} from "./DcbAddressInput";
import {RedCloseIcon} from "./RedCloseIcon";
import {GreenCheckIcon} from "./GreenCheckIcon";

interface AddressFormProps {
    label?: string;
    required?: boolean;
    initialValue?: Address;
    className?: string;
    onSubmit: (address: Address) => Promise<any>;
}

const useStyles = makeStyles(theme => ({
    spacing: {
        marginRight: theme.spacing(1)
    },
    container: {
        display: 'flex',
        alignItems: 'center'
    }
}));

export const AddressForm: FC<AddressFormProps> = (props) => {

    const classes = useStyles();
    const history = useHistory();

    const [isLoading, setIsLoading] = React.useState(false);

    const closeForm = () => history.replace({search: undefined});

    return (
        <Formik
            initialValues={
                {
                    address: props.initialValue
                        ? props.initialValue
                        : null as unknown as Address
                }
            }
            onSubmit={(values) => {
                if (values.address.placeId) {
                    setIsLoading(true);
                    props.onSubmit(values.address)
                        .catch(() => {
                        })
                        .finally(() => {
                            setIsLoading(false);
                            closeForm();
                        })
                }
            }}
            validationSchema={
                props.required
                    ? yup.object({address: yup.object({placeId: yup.string().required('benötigt')})})
                    : undefined
            }
        >
            {({submitForm, errors}) => (
                <Form className={clsx(props.className, classes.container)}>
                    <div style={{flexGrow: 1}}>
                        <FormikDcbAddressInput name={"address"} label="Auftrags" textFieldProps={{required: true}}/>
                    </div>
                    <Typography variant="subtitle1">{errors.address?.placeId}</Typography>
                    {isLoading
                        ? <CircularProgress size={20} color="secondary"/>
                        : (
                            <>
                                <IconButton edge="end" onClick={closeForm}>
                                    <RedCloseIcon/>
                                </IconButton>
                                <IconButton edge="end" onClick={submitForm}>
                                    <GreenCheckIcon/>
                                </IconButton>
                            </>
                        )
                    }
                </Form>
            )}
        </Formik>
    )
}

